module.exports = __webpack_public_path__ + "static/origin-192d2df86b6649cceeaef805aa48f6b6.png";